import { Component } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {
    CommonItemsFaqDialogComponent
} from '@emm/common-items/dialogs/common-items-faq-dialog/common-items-faq-dialog.component';

@Component({
  selector: 'emm-help-button',
  templateUrl: './help-button.component.html',
  styleUrl: './help-button.component.scss'
})
export class HelpButtonComponent {
    constructor(private dialog: MatDialog) {}

    openFaqDialog(): void {
        this.dialog.open(CommonItemsFaqDialogComponent, {
            width: '750px',
            height: '500px',
        });
    }
}
